<template>
  <div
    class="main-content"
    style="background-color: #2D3A4B; display: flex; justify-content: center; align-items: center;"
    :style="{ 'height': fullHeight + 'px'}"
  >
    <div style="">
      <el-form
        ref="loginForm"
        :model="listQuery"
        :rules="loginRules"
        class="login-form"
        autocomplete="on"
        label-position="left"
        style="width: 70vw; text-align: center; margin-top: -20vh;"
      >
        <div style="color: #FFF; font-size: 6vw; margin-bottom: 5vh;">
          登 录
        </div>

        <el-input
          v-model="listQuery.username"
          placeholder="请输入用户名"
          clearable
        />
        <el-input
          v-model="listQuery.password"
          placeholder="请输入登录密码"
          show-password
        />

        <el-button
          type="primary"
          style="width: 100%; margin-top: 3vh;"
          @click.native.prevent="handleLogin"
        >
          登录
        </el-button>
      </el-form>
    </div>

    <van-overlay
      :show="loading"
      @click="loading = false"
    >
      <div
        class="wrapper"
        @click.stop
      >
        <van-loading
          type="spinner"
          color="#1989fa"
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import { showPhoneAlarm } from '@/global/function.js'
  import { login as userLogin } from '@/api/user'
  import checkPermission from '@/utils/permission'

  export default {
    name: 'Login',
    components: {},
    data() {
      return {
        loading: false,
        fullHeight: document.documentElement.clientHeight,
        listQuery: {
          username: '',
          password: ''
        },
        loginRules: {
          username: [{
            required: true, message: '用户名不能为空', trigger: 'blur' ,
          }, {
            min: 2, max: 20, message: '长度在 5 到 20 个字符',
          }, {
            pattern: /^[A-Za-z0-9]+$/, message: '用户名只能为英文及数字',
          }],
          password: [{
            required: false,message: '请输入密码', trigger: 'blur',
          }, {
            min: 6, max: 25, message: '长度在 6 到 25个字符',
          }, {
            pattern: /^(\w){6,25}$/, message: '只能输入6-25个字母、数字、下划线',
          }]
        },
        redirect: undefined
      }
    },
    computed: {

    },
    watch: {
      $route: {
        handler(route) {
          this.redirect = (route.query && route.query.redirect) || "/";
        },
        immediate: true,
      },
    },
    beforeCreate() {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag === null) {
        const url = window.location.href
        const baseUrl = url.substr(0, url.indexOf('/ndwnq'))
        const pcUrl = baseUrl + '/ndwnq-c'
        window.location.href = pcUrl
      }
    },
    created() {

    },
    beforeMount() {

    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      checkPermission,
      handleLogin() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
        let data = new FormData()
        data.append("username", this.listQuery.username)
        data.append("password", this.listQuery.password)
        userLogin(data).then(response => {
          const { data } = response
          console.log(data)
          console.log(this.redirect)
          if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '用户登录', data.message)) {
            if (data.data.permission.length === 0) {
              showPhoneAlarm(true, 'toast', null, 2000, 500, '', "权限不能为空")
              return
            }
            let personType = data.data.personType
            this.$store.dispatch("user/loginSuccess", data).then(response => {
              if (personType === 0 || personType === 3) {
                let path = '/dashboard/order'
                if (this.redirect.indexOf("material-check") !== -1) {
                  path = this.redirect
                }
                this.$router.replace({
                  path: path,
                  query: {} ,
                }).catch(() =>{

                })
              } else {
                this.$router.replace({
                  path:'/dashboard',
                  query: {} ,
                }).catch(() =>{

                })
              }
            })
          }
          if (typeof data.data === "undefined") {
            return
          }
        }).catch(function(error) {
          console.error(error)
        })
          } else {
            showPhoneAlarm(true, 'toast', 'success', 2000, 200, '用户登录', '用户名或密码错误')
            return false
          }
        })
      }
    }
  }
</script>


<style scoped lang="scss">
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .main-content {
    font-size: .4rem;
    background-color: #F8F8F8;
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
  ::v-deep .el-input {
    margin: .2rem 0;
  }
  ::v-deep .el-input__inner {
    background-color: #283443;
    border: 1px solid #3E4856;
    color: #FFF;
  }
</style>
